'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/scroll-behavior/~/dom-helpers/util/inDOM.js
// module id = 379
// module chunks = 1